import React from "react";
import { IState, Item } from "../../../../../interfaces/interfaces";
import classNames from "classnames";
import defaultStyle from "../../../Item.module.scss";
import style from "./RowItem.module.scss";
import { getAsset } from "../../../../../utils/assets";
import { EAssetName } from "../../../../../interfaces/enum";
import { useDispatch, useSelector } from "react-redux";
import {
  addBookmarked,
  removeBookmarked,
} from "../../../../../store/actions/ItemActions";

type RowItemProps = {
  data: Item;
  isTrending: boolean;
};

const RowItem = ({ data, isTrending }: RowItemProps) => {
  const dispatch = useDispatch();
  const { bookmarked } = useSelector((state: IState) => state.item);

  const isBookmarked = () => {
    return bookmarked.find((item) => item.title === data.title);
  };
  const handleBookmarkClick = () => {
    if (isBookmarked()) {
      dispatch(removeBookmarked(data));
    } else {
      dispatch(addBookmarked(data));
    }
  };

  return (
    <>
      <div
        className={classNames(
          defaultStyle.item,
          isTrending ? defaultStyle.trendingSize : defaultStyle.sectionSize
        )}
      >
        <div
          className={classNames(
            defaultStyle.item,
            style.item,
            isTrending ? defaultStyle.trendingSize : defaultStyle.sectionSize
          )}
        >
          <img
            src={
              isTrending
                ? data.thumbnail.trending?.large
                : data.thumbnail.regular.large
            }
            alt={data.thumbnail.regular?.large}
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              position: "absolute",
              zIndex: 0,
            }}
          />
          <div
            className={classNames(
              style.content,
              isTrending && style.gradient,
              "d-flex",
              "flex-column",
              "justify-content-between"
            )}
          >
            <div className="d-flex justify-content-end">
              <div
                style={{
                  cursor: "pointer",
                }}
                className={classNames(
                  style.bookmark,
                  "d-flex",
                  "justify-content-center",
                  "align-items-center"
                )}
                onClick={handleBookmarkClick}
              >
                <img
                  src={getAsset(
                    isBookmarked()
                      ? EAssetName.BOOKMARK_FULL
                      : EAssetName.BOOKMARK_EMPTY
                  )}
                  alt="bookmark"
                />
              </div>
            </div>
            {isTrending && (
              <div className={classNames(style.allInfo)}>
                <div
                  className={classNames(style.info)}
                  dangerouslySetInnerHTML={{
                    __html: `${data.year} &#x2022; ${data.category} &#x2022; ${data.rating}`,
                  }}
                />
                <div className={classNames(style.title)}>{data.title}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default RowItem;
